/// <reference path="../../global/fn.js" />

(function ($) {
    $.widget("nsp.fullwidthGallery", {
        options: {
           
        },

        _create: function () {
            this.wrap = this.element;

            this._createDotContainer();            
            this._initSlick();            
        },

        _initSlick(){
           this.carousel =  this.wrap.find(".s-fullwidth-gallery__carousel");

           this.carousel.slick({
                edgeFriction: api.vars.slick.edgeFriction,
                infinite: false,
                arrows: true,
                prevArrow: api.vars.slick.prevArrow,
                nextArrow: api.vars.slick.nextArrow,
                dots: false,
                rows: 0,
                slidesToShow: 1,
                appendArrows: this.wrap.find(".carousel_arrows"),   
                slidesToScroll: parseInt(this.carousel.attr('data-scrollItems')),
                responsive: [
                    {
                        breakpoint: api.vars.scr.tablet - 1,
                        settings: {
                            dots: true,
                            appendDots: this.wrap.find(".carousel_dots"),
                        },
                    },
                ],
            });

            this.carousel.on('afterChange', function(event, slick, currentSlide, nextSlide){                 
                if(currentSlide != 0){
                   $('.s-fullwidth-gallery__wrp').addClass('opacityLeft')
                }       
                else{                        
                    $('.s-fullwidth-gallery__wrp').removeClass('opacityLeft')
                }              
            });

        },

        _createDotContainer() {
            $('<div class="carousel_dots"></div>').insertBefore(this.wrap.find('.s-fullwidth-gallery__row'));
        }
       
    });
})(jQuery);
